<main class="content">
  <form [formGroup]="form">
    <!-- TIPO DE PRESTAMO -->
    <section class="content--section">
      <h5 class="content--section__title">{{ 'selectLoanType' | i18next }}</h5>
      <div class="content--section__item">
        <mat-form-field class="width-standar">
          <mat-label>{{ 'loanType' | i18next }}</mat-label>
          <mat-select
            (selectionChange)="changeClass()"
            formControlName="loanType"
          >
            <mat-option
              [value]="loanOptions.LD"
              [disabled]="disableLongDuration"
            >
              {{ loanOptions.LD }}</mat-option
            ><mat-option [value]="loanOptions.CP" [disabled]="disableCarpool">
              {{ loanOptions.CP }}</mat-option
            >
            <mat-option [value]="loanOptions.W" [disabled]="disableWedding">
              {{ loanOptions.W }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </section>
    <!-- CENTRO / SI ES CARPOOL -->
    <section class="content--section mgTop" *ngIf="loanType === loanOptions.CP">
      <h5 class="content--section__title">{{ 'selectCenter' | i18next }}</h5>
      <div class="content--section__item">
        <mat-form-field class="width-standar">
          <mat-label for="class" class="loan-request--label">{{
            'center' | i18next
          }}</mat-label>
          <mat-select
            (selectionChange)="changeCenter()"
            [ngClass]="errorMsg('center')"
            name="center"
            formControlName="center"
            class="loan-request--select__input"
          >
            <mat-option value="SEAT_COMPONENTES">
              {{ 'centerSeat' | i18next }}
            </mat-option>
            <mat-option value="ZONA_FRANCA">
              {{ 'centerZone' | i18next }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>
    <small class="error-message" *ngIf="centerError">{{
      'selectCenter' | i18next
    }}</small>
    <!-- FECHAS -->
    <section class="content--section mgTop">
      <h5 class="content--section__title">
        {{ 'selectDates' | i18next }}
      </h5>
      <!-- larga duración -->
      <div
        class="content--section__dates"
        *ngIf="form.value.loanType === loanOptions.LD"
      >
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="deliveryPicker"
              formControlName="deliveryDate"
              (dateChange)="changeDate('deliveryDate')"
              [min]="minDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="deliveryPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #deliveryPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'deliveryHour' | i18next }}</mat-label>
            <mat-select
              formControlName="deliveryHour"
              (selectionChange)="updateInfo()"
              [(value)]="selectedHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  deliveredDate === today.toDateString() && hour <= actualHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'returnDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="returnPicker"
              formControlName="returnDate"
              (dateChange)="changeDate('returnDate')"
              [min]="form.value.deliveryDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="returnPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #returnPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'returnHour' | i18next }}</mat-label>
            <mat-select
              (selectionChange)="updateInfo()"
              formControlName="returnHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  deliveredDate === returnedDate &&
                  hour <= form.value.deliveryHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- car pool -->
      <div
        class="content--section__dates"
        *ngIf="form.value.loanType === loanOptions.CP"
      >
        <mat-form-field class="content--section__dateContainer">
          <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="deliveryPicker"
            formControlName="deliveryDate"
            (dateChange)="changeDate('deliveryDate')"
            [min]="minDate"
            [max]="maxDateCarpool"
            readonly
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="deliveryPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #deliveryPicker (closed)="close()"></mat-datepicker>
        </mat-form-field>
        <small class="error-message" *ngIf="deliveryDateError">
          {{ 'selectDate' | i18next }}*
        </small>
        <div *ngIf="!!form.value.deliveryDate" class="content--section__hours">
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'deliveryHour' | i18next }}</mat-label>
            <mat-select
              formControlName="deliveryHour"
              (selectionChange)="updateInfo()"
              [(value)]="selectedHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  form.value.deliveryDate.toDateString() ===
                    today.toDateString() && hour <= actualHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'returnHour' | i18next }}</mat-label>
            <mat-select
              (selectionChange)="updateInfo()"
              formControlName="returnHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="hour <= form.value.deliveryHour"
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- Bodas -->
      <div
        class="content--section__dates"
        *ngIf="form.value.loanType === loanOptions.W"
      >
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="deliveryPicker"
              [min]="minDateWeddings"
              formControlName="deliveryDate"
              (dateChange)="changeDate('deliveryDate')"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="deliveryPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #deliveryPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'deliveryHour' | i18next }}</mat-label>
            <mat-select
              formControlName="deliveryHour"
              (selectionChange)="updateInfo()"
              [(value)]="selectedHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  deliveredDate === today.toDateString() && hour <= actualHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'returnDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="returnPicker"
              formControlName="returnDate"
              (dateChange)="changeDate('returnDate')"
              [min]="form.get('deliveryDate')!.value"
              [max]="calculateMaxDate()"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="returnPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #returnPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="content--section__hours">
            <mat-label>{{ 'returnHour' | i18next }}</mat-label>
            <mat-select
              (selectionChange)="updateInfo()"
              formControlName="returnHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  deliveredDate === returnedDate &&
                  hour <= form.value.deliveryHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
    <!-- Datos del contrayente -->
    <section
      class="content--section mgTop"
      *ngIf="form.value.loanType === loanOptions.W"
    >
      <h5 class="content--section__title">
        {{ 'dataOfContractingParty' | i18next }}
      </h5>
      <div class="content--section__radio">
        <mat-checkbox
          required
          color="primary"
          type="checkbox"
          name="seatEmployee"
          id="seatEmployee"
          formControlName="seatEmployee"
          (change)="updateInfo()"
          >{{ 'isSeatEmployee' | i18next }}</mat-checkbox
        >
      </div>
      <div class="content--section__radio">
        <mat-checkbox
          required
          color="primary"
          type="checkbox"
          name="isPetitioner"
          id="isPetitioner"
          formControlName="isPetitioner"
          (change)="isPetitionerContracting()"
          >{{ 'isPetitioner' | i18next }}</mat-checkbox
        >
      </div>
      <div class="content--section__driverContainer">
        <div class="content--section__nameSearcher">
          <mat-form-field style="width: 100% !important">
            <mat-label>{{ 'introduceNis' | i18next }}</mat-label>
            <input
              matInput
              type="text"
              class="loan-request--select__input"
              formControlName="nisContract"
              (change)="updateInfoNisContract()"
            />
          </mat-form-field>
        </div>
        <div class="content--section__nameSearcher">
          <mat-form-field
            class="custom-autocomplete"
            style="width: 100% !important"
          >
            <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
            <input
              class="loan-request--select__input"
              type="text"
              matInput
              [formControl]="searchNameControl"
              formControlName="fullNameContract"
              [matAutocomplete]="auto"
              (change)="updateInfoNisContract()"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onOptionContractingSelected($event)"
            >
              <mat-option
                *ngFor="let option of filteredContractOptions | async"
                [value]="option"
              >
                {{ option.fullName }} {{ option.id }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div *ngIf="nisErrorContract" class="nisErrorContainer">
          <small class="error-message">{{ 'errorWrongNis' | i18next }}</small>
        </div>
        <div *ngIf="nisErrorLengthContract" class="nisErrorContainer">
          <small class="error-message">{{ 'nisErrorLength' | i18next }}</small>
        </div>
        <div *ngIf="errorNisNameContract" class="nisErrorContainer">
          <small class="error-message">{{
            'errorNoNisAndNoName' | i18next
          }}</small>
        </div>
        <div *ngIf="nameErrorContract" class="nisErrorContainer">
          <small class="error-message">{{ 'nameError' | i18next }}</small>
        </div>
        <div *ngIf="noNameErrorContract" class="nisErrorContainer">
          <small class="error-message">{{ 'noNameError' | i18next }}</small>
        </div>
      </div>
    </section>
    <!-- RAZONES -->
    <section
      class="content--section mgTop"
      *ngIf="form.value.loanType !== loanOptions.W"
    >
      <h5 class="content--section__title">{{ 'loanReason' | i18next }}</h5>
      <div
        class="dpFlex"
        *ngIf="form.value.loanType === loanOptions.LD || moreThanOneVehicle"
      >
        <div class="content--section__reasonInput">
          <mat-form-field class="width-standar">
            <mat-label class="loan-request--label" for="reason">{{
              'reason' | i18next
            }}</mat-label>
            <mat-select
              name="reason"
              id="reason"
              formControlName="reason"
              class="loan-request--select__input"
              (selectionChange)="changeReason($event.value)"
            >
              <mat-option
                *ngFor="let option of loanReasonsKeys"
                [value]="option"
              >
                {{ loanReasonsEnum[option] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__textarea">
          <mat-form-field class="custom-autocomplete">
            <mat-label>{{ placeholder }}</mat-label>
            <textarea
              matInput
              name="reasonText"
              id="reasonText"
              class="loan-request--textArea"
              class="content--section__textarea--input"
              formControlName="reasonText"
              (change)="changeReasonText()"
            >
            </textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="dpFlex" *ngIf="form.value.loanType === loanOptions.CP">
        <div class="content--section__reasonInput">
          <mat-form-field class="width-standar">
            <mat-label class="loan-request--label" for="reason">{{
              'reason' | i18next
            }}</mat-label>
            <mat-select
              name="reason"
              id="reason"
              formControlName="reason"
              class="loan-request--select__input"
              (selectionChange)="changeReason($event.value)"
            >
              <mat-option
                *ngFor="let option of loanReasonsCPKeys"
                [value]="option"
              >
                {{ loanReasonsCPEnum[option] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__textarea">
          <mat-form-field class="custom-autocomplete">
            <mat-label>{{ placeholder }}</mat-label>
            <textarea
              matInput
              name="reasonText"
              id="reasonText"
              class="loan-request--textArea"
              class="content--section__textarea--input"
              formControlName="reasonText"
              (change)="changeReasonText()"
            >
            </textarea>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="reasonText" class="errorReasonContainer">
        <small class="error-message">{{ placeholder }}</small>
      </div>
    </section>
    <!-- TIPO CONDUCTOR -->
    <section
      class="content--section mgTop"
      *ngIf="form.value.loanType !== loanOptions.CP"
    >
      <h5 class="content--section__title">
        {{ 'loanSelectDriverTitle' | i18next }}
      </h5>
      <div class="content--section__item">
        <mat-form-field class="loan-request--column__item width-standar">
          <mat-label for="driverType" class="loan-request--label">{{
            'loanDriver' | i18next
          }}</mat-label>
          <mat-select
            #select
            name="driverType"
            id="driverType"
            class="loan-request--select__input"
            formControlName="driverType"
            (selectionChange)="changeDriverType()"
          >
            <mat-option value="INTERNAL">{{ 'intern' | i18next }}</mat-option>
            <mat-option value="EXTERNAL">{{ 'extern' | i18next }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <small class="error-message" *ngIf="driverTypeError">{{
        'selectType' | i18next
      }}</small>
    </section>
    <!-- CONDUCTOR INTERNO -->
    <form [formGroup]="driverForm">
      <section
        class="content--section mgTop"
        *ngIf="
          form.value.driverType === 'INTERNAL' ||
          form.value.loanType === loanOptions.CP
        "
      >
        <h5
          class="content--section__title"
          *ngIf="
            form.value.driverType === 'INTERNAL' ||
            form.value.loanType === loanOptions.CP
          "
        >
          {{ 'interDriverInfo' | i18next }}
        </h5>
        <div class="content--section__driverContainer gap-4">
          <div>
            <mat-form-field class="width-standar">
              <mat-label>{{ 'introduceNis' | i18next }}</mat-label>
              <input
                matInput
                type="text"
                class="loan-request--select__input"
                formControlName="nis"
                (change)="updateInfoNis()"
              />
            </mat-form-field>
          </div>
          <div class="content--section__nameSearcher">
            <mat-form-field class="custom-autocomplete">
              <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
              <input
                class="loan-request--select__input"
                type="text"
                matInput
                [formControl]="searchControl"
                formControlName="fullName"
                [matAutocomplete]="auto"
                (change)="updateInfoNis()"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onOptionSelected($event)"
              >
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option.fullName }} {{ option.id }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="nisError" class="nisErrorContainer">
            <small class="error-message">{{ 'errorWrongNis' | i18next }}</small>
          </div>
          <div *ngIf="nisErrorLength" class="nisErrorContainer">
            <small class="error-message">{{
              'nisErrorLength' | i18next
            }}</small>
          </div>
          <div *ngIf="errorNisName" class="nisErrorContainer">
            <small class="error-message">{{
              'errorNoNisAndNoName' | i18next
            }}</small>
          </div>
          <div *ngIf="nameError" class="nisErrorContainer">
            <small class="error-message">{{ 'nameError' | i18next }}</small>
          </div>
          <div *ngIf="noNameError" class="nisErrorContainer">
            <small class="error-message">{{ 'noNameError' | i18next }}</small>
          </div>
        </div>
        <div
          class="content--section__driverContainer gap-4"
          *ngIf="form.value.loanType === loanOptions.W"
        >
          <div>
            <mat-form-field class="width-standar">
              <mat-label>{{ 'city' | i18next }}</mat-label>
              <input
                matInput
                type="text"
                class="loan-request--select__input"
                formControlName="city"
                (change)="updateInfo()"
              />
            </mat-form-field>
          </div>
          <div class="content--section__nameSearcher">
            <mat-form-field class="custom-autocomplete">
              <mat-label>{{ 'address' | i18next }}</mat-label>
              <input
                matInput
                type="text"
                class="loan-request--select__input"
                formControlName="address"
                (change)="updateInfo()"
              />
            </mat-form-field>
          </div>
        </div>
        <div
          class="content--section__dates"
          *ngIf="form.value.loanType === loanOptions.W"
        >
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'postalCode' | i18next }}</mat-label>
            <input
              matInput
              type="text"
              class="loan-request--select__input"
              formControlName="postalCode"
              (change)="updateInfo()"
            />
          </mat-form-field>
        </div>
      </section>
      <!-- CONDUCTOR EXTERNO -->
      <section
        class="content--section mgTop"
        *ngIf="form.value.driverType === 'EXTERNAL'"
      >
        <h5 class="content--section__title">
          {{ 'externDriverInfo' | i18next }}
        </h5>
        <div class="mgLeft">
          <p class="content--section__driverContainer--subtitle">
            {{ 'loanExternDriverText' | i18next }}
            <span class="bold">{{ 'requiredFields' | i18next }}</span>
          </p>
          <small class="error-message" *ngIf="externInfoError">{{
            'requiredFields' | i18next
          }}</small>
          <div class="content--section__externContainer">
            <div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'dni' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="dni"
                    type="text"
                    placeholder="{{ 'dni' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('dni')"
                    [ngClass]="errorMsgExternInfo('dni')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'name' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="name"
                    type="text"
                    placeholder="{{ 'name' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('name')"
                    [ngClass]="errorMsgExternInfo('name')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'address' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="address"
                    type="text"
                    placeholder="{{ 'address' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('address')"
                    [ngClass]="errorMsgExternInfo('address')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'city' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="city"
                    type="text"
                    placeholder="{{ 'city' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('city')"
                    [ngClass]="errorMsgExternInfo('city')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
            </div>
            <div class="content--section__externContainer--section column2">
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'phone' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="telephone"
                    type="text"
                    placeholder="{{ 'phone' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('telephone')"
                    [ngClass]="errorMsgExternInfo('telephone')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'surnames' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="lastName"
                    type="text"
                    placeholder="{{ 'surnames' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('lastName')"
                    [ngClass]="errorMsgExternInfo('lastName')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'postalCode' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="postalCode"
                    type="text"
                    placeholder="{{ 'postalCode' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('postalCode')"
                    [ngClass]="errorMsgExternInfo('postalCode')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
              <div class="content--section__externContainer--item">
                <mat-form-field class="width-standar">
                  <mat-label>{{ 'email' | i18next }}</mat-label>
                  <input
                    matInput
                    class="content--section__select__input extern"
                    formControlName="email"
                    type="email"
                    placeholder="{{ 'email' | i18next }}"
                    (change)="updateInfo()"
                  />
                </mat-form-field>
                <div class="externalInfoError">
                  <small
                    *ngIf="errorMsgExternInfo('email')"
                    [ngClass]="errorMsgExternInfo('email')"
                    >{{ 'requieredField' | i18next }}</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="content--section"
        *ngIf="form.value.driverType !== '' || enableCheckboxLicense"
      >
        <div class="content--section__radio">
          <mat-checkbox
            required
            color="primary"
            type="checkbox"
            name="driverLicense"
            id="driverLicense"
            formControlName="driverLicense"
            (change)="updateInfo()"
            >{{ 'loanDriverLicense' | i18next }}</mat-checkbox
          >
        </div>
      </section>
    </form>
  </form>
</main>
